import React from 'react';
import { LayoutDashboardIcon, UsersIcon, PieChartIcon, SettingsIcon, LogOutIcon } from 'lucide-react';
interface SidebarProps {
  activeView: string;
  onNavigate: (view: string, path: string) => void;
}
export const Sidebar: React.FC<SidebarProps> = ({
  activeView,
  onNavigate
}) => {
  const menuItems = [{
    id: 'overview',
    icon: LayoutDashboardIcon,
    label: 'Overview',
    path: '/'
  }, {
    id: 'residents',
    icon: UsersIcon,
    label: 'Residents',
    path: '/residents'
  }, {
    id: 'reports',
    icon: PieChartIcon,
    label: 'Reports',
    path: '/reports'
  }, {
    id: 'settings',
    icon: SettingsIcon,
    label: 'Settings',
    path: '/settings'
  }];
  return <aside className="bg-white border-r border-gray-200 w-64 flex flex-col" data-id="element-171">
      <div className="p-4 border-b border-gray-200" data-id="element-172">
        <div className="flex items-center justify-center" data-id="element-173">
          <img src="https://cdn.prod.website-files.com/659d7a614547395209129493/659d7f03d0f0964a1827a48b_New%20Logo.svg" alt="Further Logo" className="h-8" data-id="element-174" />
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto py-4" data-id="element-175">
        <ul className="space-y-1" data-id="element-176">
          {menuItems.map(item => {
          const Icon = item.icon;
          return <li key={item.id} data-id="element-177">
                <button onClick={() => onNavigate(item.id, item.path)} className={`flex items-center w-full px-4 py-3 text-left ${activeView === item.id ? 'bg-[#1f58b0] text-white' : 'text-gray-700 hover:bg-gray-100'} transition-colors rounded-md mx-2`} data-id="element-178">
                  <Icon className="h-5 w-5 mr-3" data-id="element-179" />
                  <span data-id="element-180">{item.label}</span>
                </button>
              </li>;
        })}
        </ul>
      </nav>
      <div className="p-4 border-t border-gray-200" data-id="element-181">
        <button className="flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md w-full mt-2" data-id="element-182">
          <LogOutIcon className="h-5 w-5 mr-3" data-id="element-183" />
          <span data-id="element-184">Log out</span>
        </button>
      </div>
    </aside>;
};